export class ToLowerCaseValueConverter {
    toView(value) {
        if (value) {
            return value.toLowerCase();
        }
        return null;
    }

    fromView(value) {
        if (value) {
            return value.toLowerCase();
        }
        return null;
    }
}